import React, {useCallback, useEffect} from "react";
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import Styles from './styles.module.scss';
import {useDispatch, useSelector} from "react-redux";
import {getAllocationVestingDetails, setSettingsAllocationDetailsModalStatus} from "../../store/cabinet/action";

import {useTranslation} from "react-i18next";

const SettingsAllocationDetailsModal = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const settingsAllocationDetailsModalStatus = useSelector(store => store.cabinet.settingsAllocationDetailsModalStatus);
    const allocationVestingDetails = useSelector(store => store.cabinet.allocationVestingDetails);
    const userAllocation = useSelector(store => store.cabinet.userAllocation);

    const closeModal = useCallback(() => {
        dispatch(setSettingsAllocationDetailsModalStatus({status: false, data: false}));
    }, [dispatch]);

    useEffect(()=>{
        if (settingsAllocationDetailsModalStatus?.status){
            dispatch(getAllocationVestingDetails(settingsAllocationDetailsModalStatus?.data?.project?.slug))
        }
    },[settingsAllocationDetailsModalStatus, dispatch])


    const calculatePercentOfTotal = (allocation_total, percent) => {
        if (!allocation_total || !percent) return 0;
        return ((allocation_total * percent) / 100) / userAllocation?.allocations[0]?.project?.price_per_token;
    };

    return (
        <Popup
            open={settingsAllocationDetailsModalStatus?.status}
            modal
            nested
            closeOnDocumentClick={false}
            closeOnEscape={false}
            onClose={closeModal}
        >
            <div className={Styles.modalContainer}>
                <div className={Styles.modalCloseBtn} onClick={closeModal}>
                    <div/>
                    <div/>
                </div>
                <div className={`${Styles.modalContentWrap}`}>
                    <div className={`${Styles.modalContentBox}`}>
                        <div className={`${Styles.modalContentBoxInfoWrap}`}>
                            <div className={`${Styles.titleRow}`}>
                                <div className={`${Styles.titleRowImgWrap}`}>
                                    <img src={settingsAllocationDetailsModalStatus?.data?.project?.logo} alt={settingsAllocationDetailsModalStatus?.data?.project?.description?.title}/>
                                </div>
                                <div className={`${Styles.titleRowAllocationWrap}`}>
                                    <div className={`${Styles.titleRowAllocationWrapTitle}`}>{settingsAllocationDetailsModalStatus?.data?.project?.description?.title}</div>
                                    <div className={`${Styles.titleRowAllocationWrapNote}`}>{settingsAllocationDetailsModalStatus?.data?.project?.description?.short_description}</div>
                                    <div className={`${Styles.titleRowAllocationPosWrap}`}>
                                        <div className={`${Styles.titleRowAllocation}`}>
                                            <div className={`${Styles.titleRowAllocationName} ${Styles.titleWSF}`}>{t('Сумма аллокации')}</div>
                                            <div className={`${Styles.titleRowAllocationValue} ${Styles.titleWSF}`}>{settingsAllocationDetailsModalStatus?.data?.allocation_total * 1}$</div>
                                        </div>
                                        <div className={`${Styles.titleRowAllocation}`}>
                                            <div className={`${Styles.titleRowAllocationName} ${Styles.titleWSF}`}>{t('Сумма инвестиций')}</div>
                                            <div className={`${Styles.titleRowAllocationValue} ${Styles.titleWSF}`}>{settingsAllocationDetailsModalStatus?.data?.allocation_invested * 1}$</div>
                                        </div>
                                    </div>
=
                                </div>
                            </div>
                        </div>
                        <div className={`${Styles.tableWrap}`}>
                            <div className={`${Styles.tableWrapTitleRow}`}>
                                <div className={`${Styles.titleRowItem}`}>{t('Дата')}</div>
                                <div className={`${Styles.titleRowItem}`}>{t('Сумма')}</div>
                                <div className={`${Styles.titleRowItem}`}>% <span>{t('от общего кол-ва')}</span></div>
                            </div>
                            <div className={`${Styles.tableBox}`}>
                                {allocationVestingDetails?.periods?.length > 0 ? allocationVestingDetails?.periods.map((item, index)=>{
                                    return (
                                        <div className={`${Styles.tableRow} ${item.is_received ? Styles.tableRowColored : null}`} key={'tableRow' + index}>
                                            <div className={`${Styles.tableRowItem}`}>{item.date}</div>
                                            <div className={`${Styles.tableRowItem}`}>{calculatePercentOfTotal(userAllocation?.allocations[0].allocation_invested, item.percent)}{userAllocation?.allocations[0]?.project?.token}</div>
                                            <div className={`${Styles.tableRowItem}`}>{item.percent}%</div>
                                        </div>
                                    )
                                }) : null}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Popup>
    );
};

export default SettingsAllocationDetailsModal;

